import { formatDistance } from 'date-fns'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useDrafts } from '../../queries/drafts'
import CenteredLoadingAnimation from '../core/CenteredLoadingAnimation'
import Text from '../core/Text/Text'

const DraftsGodlist = () => {
  const { data, isLoading, isError, fetchNextPage, hasNextPage } = useDrafts({
    all: true,
    orderBy: 'updatedAt',
    order: 'desc'
  })

  return (
    <>
      <Text size="24" css={{ marginBottom: '$16' }}>
        Drafts Godlist
      </Text>
      {isError && (
        <Text size="20" css={{ color: 'red' }}>
          Something went wrong!
        </Text>
      )}
      {isLoading ? (
        <CenteredLoadingAnimation />
      ) : (
        <>
          <div className="fw-bold" style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ flex: '1' }}>Draft Name</div>
            <div style={{ flex: '1' }}>User Display Name</div>
            <div style={{ flex: '2' }}>Wallet</div>
            <div style={{ flex: '1' }}>Last edited</div>
          </div>
          <InfiniteScroll
            loader={<CenteredLoadingAnimation />}
            dataLength={data?.pages.length * 50}
            next={fetchNextPage}
            hasMore={hasNextPage}
            style={{ overflow: 'visible' }}
          >
            {data.pages.map((page) =>
              page.data.map((draft) => (
                <div
                  style={{ display: 'flex', flexDirection: 'row', borderTop: '1px solid black' }}
                  key={`${draft.user.walletAddress}_${draft.name}`}
                  className="underline-on-hover"
                >
                  <div style={{ flex: '1' }}>{draft.name}</div>
                  <div style={{ flex: '1' }}>{draft.user.displayName}</div>
                  <div style={{ flex: '2' }}>{draft.user.walletAddress}</div>
                  <div style={{ flex: '1' }}>
                    {formatDistance(new Date(draft.updatedAt), new Date(), { addSuffix: true })}
                  </div>
                </div>
              ))
            )}
          </InfiniteScroll>
          {}
        </>
      )}
    </>
  )
}

export default DraftsGodlist
